module.exports = {
      id: "shortvideo-usage",
      viewBox: "0 0 15 19",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#shortvideo",
      toString: function () {
        return this.url;
      }
    }